import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrinter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 16H16L17 21H7L8 16Z",
			stroke: "currentColor",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 3H16V7H8V3Z",
			stroke: "currentColor",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 9C4 7.89543 4.89543 7 6 7H18C19.1046 7 20 7.89543 20 9V16H4V9Z",
			stroke: "currentColor",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 13H16",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 10H16",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		})
	]
});
export default SvgPrinter;
